import {
  APIConstants,
  FEMALE_SPECIALITIES_MAXIMUM_AGE,
  FEMALE_SPECIALITIES_MINIMUM_AGE,
  PopulationType,
} from '../../services/Constants';
import { isMnrMember } from '../../services/obapi/obapiUtis';
import { parseLOB } from '../../services/pes/utils.params';
import { calculateAge } from '../dateUtils/dateUtil';

export const getMemberRelvancySpecialityRollupCodes = (args) => {
  const {
    memberDemographics,
    providerType,
    lob,
    population,
    useNewAgeAndGenderRollups,
    pcpIndicator,
  } = args;
  let rollupCodeContent = '';
  if (!providerType) {
    return rollupCodeContent;
  }
  const providerTypeKey = providerType.toUpperCase();
  const memberAge = calculateAge(memberDemographics?.dateOfBirth);
  const memberGender = memberDemographics?.gender || {};
  const isMnr = isMnrMember(population === PopulationType.COSMOS, lob);
  const memberRelevancyData = useNewAgeAndGenderRollups
    ? APIConstants.NEW_MEMBER_RELEVANCY_CODES
    : APIConstants.MEMBER_RELEVANCY_CODES;
  if (memberAge != null) {
    if (memberAge > FEMALE_SPECIALITIES_MAXIMUM_AGE) {
      rollupCodeContent =
        memberRelevancyData[
          APIConstants.MEMBER_RELEVANCY_CONFIG.ROLLUPCODES_ABOVE21_SPECIALITIES
        ][providerTypeKey];
      if (!useNewAgeAndGenderRollups && pcpIndicator && isMnr) {
        const mnrSpecificRollupcode =
          memberRelevancyData[
            APIConstants.MEMBER_RELEVANCY_CONFIG
              .ROLLUPCODES_ABOVE21_SPECIALITIES
          ][`${providerTypeKey}_${parseLOB(lob)}`];
        rollupCodeContent = `${rollupCodeContent},${mnrSpecificRollupcode}`;
      }
    } else {
      rollupCodeContent =
        memberRelevancyData[
          APIConstants.MEMBER_RELEVANCY_CONFIG.ROLLUPCODES_UNDER21_SPECIALITIES
        ][providerTypeKey];
    }

    if (
      memberGender === 'FEMALE' &&
      memberAge >= FEMALE_SPECIALITIES_MINIMUM_AGE &&
      memberAge <= FEMALE_SPECIALITIES_MAXIMUM_AGE
    ) {
      const femaleSpecialitiesRollupCodes =
        memberRelevancyData[
          APIConstants.MEMBER_RELEVANCY_CONFIG.ROLLUPCODES_FEMALE_SPECIALITIES
        ][providerTypeKey];
      rollupCodeContent = femaleSpecialitiesRollupCodes.concat(
        ',',
        rollupCodeContent
      );
    }
  }
  return rollupCodeContent;
};
